/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../utils/Api";
import SyncLoader from "react-spinners/SyncLoader";
import noti from "../assets/bg-img/WhatsApp Image 2025-01-21 at 12.30.09 PM.jpeg"
import tick from "../assets/bg-img/bluetick.png"
import axios from "axios";

// ChatItem component to display each message
const ChatItem = ({ outgoing, avatar, message, time, seen }) => {
  return (
    <div className={`single-chat-item ${outgoing ? "outgoing" : ""}`}>
      <div className="user-avatar mt-1">
        <span className="name-first-letter">{avatar ? avatar[0] : "A"}</span>
        {avatar && <img src={avatar} alt="avatar" />}
      </div>
      <div className="user-message">
        <div className="message-content">
          {message.map((msg, index) => (
            <div
              className="single-message"
              style={{ marginRight: "13px" }}
              key={index}
            >
              {msg.text && <p dangerouslySetInnerHTML={{ __html: msg.text }} />}
            </div>
          ))}
        </div>
        <div className="message-time-status">
          <div className="sent-time">{time}</div>
          {seen && (
            <div className="sent-status seen">
              <i className="bi bi-check"></i>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const branchId = localStorage.getItem("branchId");
  const enrollId = localStorage.getItem("enrollId");

  // const defaultMessage = {
  //   text: `
  //     Dear Parent, 🎉 Congratulations! 🎉
  //     <br><br>
  //     Your child, {#var#}, has qualified by securing the {#var#} rank in the Sarvajna Scholarship Admission Test!
  //     <br><br>
  //     He/She is eligible for PU 1 Science, which includes coaching for JEE, NEET, and CET.
  //     <br><br>
  //     📌 For admission, please meet Prof. Channareddy Patil on or before {#var#} between 10 AM to 6 PM at Sarvajna College, Kalaburagi.
  //     <br><br>
  //     📞 Contact: 8050057184 | 9844488138
  //     <br><br>
  //     Best Regards, Sarvajna PU College of Science
  //   `,
  // };

  // const fetchToken = async () => {
  //   try {
  //     const fd = new FormData();
  //     fd.append("programType", "getToken");

  //     const response = await api.post("/token/tokenCurl", fd);

  //     if (response.data.success) {
  //       setToken(response.data.data);
  //     } else {
  //       console.error("Error fetching token:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching token:", error);
  //   }
  // };

  const fetchNotifications = async () => {
    const token = localStorage.getItem("authToken");
    const enrollId = localStorage.getItem("enrollId");
    const branchId = localStorage.getItem("branchId");

    try {
      const fd = new FormData();
      fd.append("programType", "getEventDetails");
      fd.append("authToken", token);
      fd.append("centerBranch", branchId);
      fd.append("enrollId", enrollId);

      // console.log("Token:", localStorage.getItem("authToken"));
      // console.log("Enroll ID:", localStorage.getItem("enrollId"));
      // console.log("Branch ID:", localStorage.getItem("branchId"));
      

      const response = await api.post("events/events", fd);
      console.log("res",response)

      if (response.data?.data) {
        setNotifications(response.data.data);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (authToken) {
  //     fetchToken();
  //   }
  // }, [authToken]);

  useEffect(() => {
   
      fetchNotifications();
    
  }, []);

  const notificationsWithDefaultMessage = [ ...notifications];

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };
  
  return (
    <div>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SyncLoader
            color="orange"
            size={12}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}

      {!loading && (
        <div style={{ marginTop: "40px" }}>
          <div className="header-area" id="headerArea">
            <div className="container">
              <div className="header-content position-relative d-flex align-items-center justify-content-between">
                <div className="chat-user--info d-flex align-items-center">
                  <div
                    className="back-button"
                    style={{ marginLeft: "-10px", marginRight: "10px" }}
                  >
                    <Link to="/home">
                      <i className="bi bi-arrow-left-short"></i>
                    </Link>
                  </div>
                  <div className="user-thumbnail-name d-flex align-items-center">
                   
                    <div className="info  d-flex justify-content-between align-items-center w-100">
                      <h4 className="mb-0">Updates</h4>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="chat-content-wrap"
            style={{
              paddingTop: "60px",
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              paddingBottom: "10px",
              marginBottom: "100px",
              marginLeft: "15px",
              marginRight: "0px",
            }}
          >
            {notificationsWithDefaultMessage.map((notification, index) => (
              <ChatItem
                key={index}
                outgoing={false}
                avatar="/assets/srvLogo.png"
                message={[{ text: notification.text || notification.remark }]}
                time={formatDate(notification.start_date)}  // ✅ 25-02-25
                seen={false}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
